import React, { Component } from "react";
import { Button, Input, Select, Modal, Icon, message } from "antd";
import { cropImage } from "@/utils/tools";
import { formatTime } from "@/utils/format";
import ChangeDomainModal from "./ChangeDomainModal";
import {
  getSiteDomainDetail,
  getSiteDomainList,
  checkDomain
} from "@api/taobaoDomainChange";
import { getUser } from "@/api/nav";
import "./style.less";

const { Option } = Select;
const clsPrefix = "domainOverview";
const domainDetailList = [
  "今日访问流量",
  "域名切换次数",
  "实时检测次数",
  "域名封禁次数"
];
let domainInfoMap = {
  expireTime: "失效时间",
  status: "状态",
  reason: "原因"
};
class DomainOverview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowChangeModal: false,
      isShowTestModal: false,
      viewDomain: "",
      domainList: [],
      userId: ""
    };
  }

  componentDidMount() {
    getUser().then(res => {
      this.setState({ userId: res.data.user_id }, () => {
        const { userId } = this.state;
        getSiteDomainDetail(userId).then(res => {
          this.setState({ domainDetail: res });
        });
        getSiteDomainList(userId).then(res => {
          this.setState({ domainList: res });
        });
      });
    });
  }

  showModal(key) {
    this.setState({ [key]: true });
  }

  setVisible(key) {
    this.setState({ [key]: false });
  }
  viewDomainDetail(viewDomain) {
    this.setState({ viewDomain });
  }

  showTestModal() {
    const { userId } = this.state;
    checkDomain(userId)
      .then(res => {
        const { status } = res;
        let convertStatus = status === false ? "不可用" : "可用";
        Modal.success({
          title: <div>当前域名在微信中的访问状态：{convertStatus}</div>,
          icon: (
            <Icon
              type={status === false ? "close-circle" : "check-circle"}
              theme='filled'
              style={{
                fontSize: "16px",
                color: `${status === true ? "#52C41A" : "#F5222D"} `,
                marginLeft: 80,
                marginTop: 3
              }}
            />
          ),
          okText: "确定",
          width: 564
        });
      })
      .catch(err => {
        message.error("检测失败");
      });
  }

  render() {
    const {
      isShowChangeModal,
      domainDetail = {},
      domainList,
      viewDomain,
      userId
    } = this.state;
    const {
      domain,
      surplusDay,
      surplusCount,
      logo,
      pv,
      uv,
      dayChangeLimit,
      domainChangeNum,
      accDomainChangeCount,
      realTimeCount,
      domainBannedCount
    } = domainDetail;

    return (
      <div className={clsPrefix}>
        <div className={`${clsPrefix}__topPart`}>
          <div>
            <div className={`${clsPrefix}__topPart--myDomain`}>
              <div className={`${clsPrefix}__topPart--myDomain--leftDomain`}>
                <div
                  className={`${clsPrefix}__topPart--myDomain--leftDomain--logo`}
                >
                  {logo ? (
                    <img src={cropImage(logo, 36, 36)} alt='logo' />
                  ) : (
                    "LOGO"
                  )}
                </div>
                <p
                  className={`${clsPrefix}__topPart--myDomain--leftDomain--domainName`}
                >
                  {domain && `${domain}.kuaizhan.com`}
                </p>
              </div>

              <div className={`${clsPrefix}__topPart--myDomain--rightBtn`}>
                <Button
                  onClick={() => {
                    this.showModal("isShowChangeModal");
                  }}
                >
                  切换域名
                </Button>
                <Button
                  onClick={() => {
                    this.showTestModal();
                  }}
                  type='primary'
                >
                  手动检测
                </Button>
                {isShowChangeModal ? (
                  <ChangeDomainModal
                    userId={userId}
                    visible={isShowChangeModal}
                    setVisible={() => this.setVisible("isShowChangeModal")}
                    initDomain={domain}
                  />
                ) : null}
              </div>
            </div>
          </div>

          <div className={`${clsPrefix}__topPart--text`}>
            <div className={`${clsPrefix}__topPart--text-surplus`}>
              <p>
                剩余次数：
                <span className={`${clsPrefix}__topPart--text-surplus-number`}>
                  {surplusCount}
                </span>
                次
              </p>
            </div>
          </div>
        </div>
        <div className={`${clsPrefix}__middlePart`}>
          {domainDetailList.map((domainInfo, index) => {
            return (
              <div key={index} className={`${clsPrefix}__middlePart--item`}>
                <div className={`${clsPrefix}__middlePart--item-strip`} />
                <h2 className={`${clsPrefix}__middlePart--item-name`}>
                  {domainInfo}
                </h2>
                {index === 0 || index === 1 ? (
                  <div className={`${clsPrefix}__middlePart--item-detail`}>
                    <div
                      className={`${clsPrefix}__middlePart--item-detail--quota`}
                    >
                      <p
                        className={`${clsPrefix}__middlePart--item-detail--quota--title`}
                      >
                        {index === 0 ? "pv" : "今日"}
                      </p>
                      <p
                        className={`${clsPrefix}__middlePart--item-detail--quota--data`}
                      >
                        {index === 0 ? pv : domainChangeNum}
                      </p>
                    </div>
                    <div
                      className={`${clsPrefix}__middlePart--item-detail--quota`}
                    >
                      <p
                        className={`${clsPrefix}__middlePart--item-detail--quota--title`}
                      >
                        {index === 0 ? "uv" : "累计"}
                      </p>
                      <p
                        className={`${clsPrefix}__middlePart--item-detail--quota--data`}
                      >
                        {index === 0 ? uv : accDomainChangeCount}
                      </p>
                    </div>
                  </div>
                ) : (
                  <div
                    className={`${clsPrefix}__middlePart--item-endTwoDetail`}
                  >
                    {index === 2 ? realTimeCount : domainBannedCount}
                  </div>
                )}
              </div>
            );
          })}
        </div>
        <div className={`${clsPrefix}__bottomPart`}>
          <Select
            style={{ width: 552, margin: "32px 0 0 32px" }}
            defaultValue={domainList && domainList[0] && domainList[0].domain}
            placeholder={
              domainList[0] ? domainList[0].domain : "域名切换历史记录"
            }
            onChange={item => this.viewDomainDetail(item)}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
          >
            {domainList &&
              domainList.map((item, index) => {
                return (
                  <Option value={item.domain} key={index}>
                    {item.domain}
                  </Option>
                );
              })}
          </Select>
          <div className={`${clsPrefix}__bottomPart--domainDetail`}>
            <div
              className={`${clsPrefix}__bottomPart--domainDetail--detailWrapper`}
            >
              {domainList.length > 0 ? (
                domainList
                  .filter((item, index) => {
                    return viewDomain
                      ? viewDomain === item.domain
                      : index === 0;
                  })
                  .map((item, index) => {
                    return (
                      <div key={index}>
                        {["expireTime", "status", "reason"].map(
                          (info, index) => {
                            return (
                              <div
                                className={`${clsPrefix}__bottomPart--domainDetail--detailWrapper--domain`}
                                key={index}
                              >
                                <span>{domainInfoMap[info]}:</span>
                                <span>
                                  {info === "expireTime"
                                    ? formatTime(item[info])
                                    : info === "status"
                                    ? item[info] === 0
                                      ? "不可用"
                                      : "可用"
                                    : item[info]}
                                </span>
                              </div>
                            );
                          }
                        )}
                      </div>
                    );
                  })
              ) : (
                <div
                  style={{
                    textAlign: "center",
                    marginTop: 50,
                    color: "#ccd"
                  }}
                >
                  <Icon type='inbox' style={{ fontSize: "50px" }} />
                  <p>暂无数据</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default DomainOverview;
